export const channelsToShow = [
    { key: "Direct", label: "utils.direct", value: "Direct" },
    {
        key: "Organic Search",
        label: "utils.organicSearch",
        state: "digitalsuite_website_search_overview",
        value: "Organic search",
    },
    {
        key: "Paid Search",
        label: "utils.paidSearch",
        state: "digitalsuite_website_search_overview",
        value: "Paid search",
    },
    {
        key: "Search - Organic",
        label: "utils.search.organic",
        state: "digitalsuite_website_search_overview",
        value: "Search - Organic",
    },
    {
        key: "Search - Paid",
        label: "utils.search.paid",
        state: "digitalsuite_website_search_overview",
        value: "Search - Paid",
    },
    {
        key: "Referrals",
        label: "utils.referrals",
        state: "digitalsuite_website_referrals_incomingtraffic",
        value: "Referrals",
    },
    {
        key: "Display Ads",
        label: "utils.displayads",
        state: "digitalsuite_website_display_overview",
        value: "Display ads",
    },
    { key: "Social", label: "utils.social", state: "digitalsuite_website_social_overview", value: "Social" },
    {
        key: "Social - Organic",
        label: "utils.social.organic",
        state: "digitalsuite_website_social_overview",
        value: "Social - Organic",
    },
    {
        key: "Social - Paid",
        label: "utils.social.paid",
        state: "digitalsuite_website_social_overview",
        value: "Social - Paid",
    },
    { key: "Email", label: "utils.email", value: "Email" },
    { key: "Gen AI", label: "utils.gen.ai", value: "Gen AI" },
    { key: "Affiliates", label: "utils.affiliates", value: "Affiliates" },
];

export const totalChangeRow = {
    channel: "mmx.total.change",
    disableHeatmap: true,
};

export const POP_DEFAULT_DURATION = "1m";
export const YOY_DEFAULT_DURATION = "12m";

export const PLUS_SIGN = "+";
export const MINUS_SIGN = "-";
